import { render, staticRenderFns } from "./Fr.vue?vue&type=template&id=5ab3ea0e&scoped=true&"
import script from "./Fr.vue?vue&type=script&lang=js&"
export * from "./Fr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab3ea0e",
  null
  
)

export default component.exports